/**
 * Toggles header--frosted-top while the page is at scroll position 0 (before user scrolls).
 */
(function () {
  var throttleDelay = 16;
  var lastRun = 0;

  function throttle(fn) {
    return function () {
      var now = Date.now();
      if (now - lastRun < throttleDelay) return;
      lastRun = now;
      fn();
    };
  }

  function getHeader() {
    return document.querySelector('.shopify-section--header store-header.header--frosted-before-scroll');
  }

  function updateFrostedTop() {
    var header = getHeader();
    if (!header) return;

    var threshold = parseInt(header.getAttribute('data-frosted-scroll-threshold') || '20', 10);
    var menusOpen = header.querySelectorAll('[open]').length > 0;
    var atTop = window.scrollY < threshold && !menusOpen;

    header.classList.toggle('header--frosted-top', atTop);
  }

  function init() {
    var header = getHeader();
    if (!header || header.hasAttribute('data-frosted-scroll-ready')) return;

    header.setAttribute('data-frosted-scroll-ready', '');
    var onUpdate = throttle(updateFrostedTop);

    window.addEventListener('scroll', onUpdate, { passive: true });
    header.addEventListener('toggle', onUpdate, { capture: true });
    window.addEventListener('pageshow', onUpdate);
    document.addEventListener('shopify:section:load', onUpdate);

    updateFrostedTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  customElements.whenDefined('store-header').then(init);
})();
